__turbopack_context__.v({
  "logo": "style-module-scss-module__OQxt6W__logo",
  "logos": "style-module-scss-module__OQxt6W__logos",
  "mainText": "style-module-scss-module__OQxt6W__mainText",
  "section": "style-module-scss-module__OQxt6W__section",
});
